export const FORM_ID = 'ppcreditapply';
export const SECCI_FORM_ID = 'ppcreditapply_secci';
export const CA_FORM_ID = 'ppcreditapply_ca';
export const CONTRACT_FORM_ID = 'ppcreditapply_contract';
export const SUBMIT_NORMALIZED_ADDRESS = 'ppcreditapply_normalize';
export const SIGN_UP_FORM_ID = 'ppcreditapply_signup';
export const COMPLETE_FORM_ID = 'ppcreditapply_complete';
export const CYCO_FORM_ID = 'ppcreditapply_cyco';
export const APP_PREFIX = '/ppcreditapply';

export const FLOW_TYPE = {
    DIRECT_APP: 'da',
    HERMES: 'he',
    PROX: 'px',
    TESLA: 'te',
    VENICE: 've'
};

export const ACTOR = {
    EBAY: 'EBAY',
    PAYPAL: 'PAYPAL',
    MERCHANT: 'MERCHANT'
};

export const COUNTRY = {
    UNITED_STATES: 'us',
    GREAT_BRITAIN: 'gb',
    GERMANY: 'de',
    AUSTRALIA: 'au'
};

export const CREDIT_TYPE = {
    CORE: 'CORE',
    INSTALLMENTS: 'INST',
    NO_INTEREST: 'NI',
    INCENTIVES: 'INCENTIVES',
    DEFAULT: 'DEFAULT'
};

export const WINDOW_NAME_PPFRAME = 'PPFrame';

export const LOCALE = {
    PROPERTY_NOT_FOUND: 'property_not_found'
};

export const NETWORK = {
    REQUEST: {
        XHR: {
            HEADER: {
                'X-Requested-With': 'XMLHttpRequest',
                'Content-Type': 'application/json'
            }
        }
    }
};

export const ERROR = {
    TYPE: {
        PP_CREDIT: 'ppCredit',
        PP_ACCOUNT: 'ppAccount',
        WIRED_OFF: 'wiredOff',
        NO_SESSION: 'noSession'
    }
};

export const PAYPAL_HOME_URI = 'https://www.paypal.com';

export const REDIRECT_SUFFIX = {
    PAY_IN_FULL_REDIRECT: 'payInFullNowFlow',
    CANCEL_REDIRECT: 'cancelFlow',
    LOGIN_REDIRECT: 'loginRedirectFlow',
    RETURN_REDIRECT: 'returnFlow'
};

export const ANS_STATUS_MAP = [
    'POSTAL_CODE_LEVEL_0',
    'POSTAL_CODE_LEVEL_1',
    'LOCALITY_LEVEL_0',
    'LOCALITY_LEVEL_1',
    'PROVINCE_LEVEL_0',
    'PROVINCE_LEVEL_1',
    'STREET_LEVEL_0',
    'STREET_LEVEL_1',
    'STREET_NUMBER_LEVEL_0',
    'STREET_NUMBER_LEVEL_1',
    'DELIVERY_SERVICE_LEVEL_0',
    'DELIVERY_SERVICE_LEVEL_1',
    'BUILDING_LEVEL_0',
    'BUILDING_LEVEL_1',
    'SUBBUILDING_LEVEL_0',
    'SUBBUILDING_LEVEL_1',
    'ORGANIZATION_LEVEL_0',
    'ORGANIZATION_LEVEL_1',
    'COUNTRY_LEVEL_0',
    'COUNTRY_LEVEL_1'
];

export const ADDRESS_RESOLUTION_CODES = {
    OK: 0,
    MISSING_ELEMENTS: 2,
    WRONG_NUMERIC_VALUE: 3,
    MULTIPLE_INPUTS: 4,
    INPUT_AMBIGUOUS: 5,
    ELEMENT_CONTRADICTION: 6,
    THREE_STRIKES: 7,
    GENERAL_POSTAL_AUTHORITY_RULE: 8
};
